    <template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="10">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="2 mt-4">
                <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToExcel" variant="info" class="mb-2 btn-download float-right"><font-awesome-icon icon="download"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom"></div>
        <b-row>
            <b-col md="12">
                <b-row class="mt-3 mb-2">
                    <b-col md="3 mb-2">
                        <b-form-input v-model="tableFilter.search_name" v-on:afterHit="doFilter" placeholder="Name" customQueryParamName="search" />
                    </b-col>
                    <b-col md="3 mb-2" v-if="$store.getters['account/accountData'].roleDownStream[0].role === 'ADMIN'">
                        <b-form-select v-model="tableFilter.branch" :options="branchList" />
                    </b-col>
                    <b-col md="3 mb-2">
                        <b-form-select v-model="tableFilter.statusJob" :options="statusList" />
                    </b-col>
                    <b-col md="3 mb-2">
                        <date-picker v-model="tableFilter.date" type="datetime" range format="YYYY-MM-DD hh:mm:ss" placeholder="Date & Time Range"></date-picker>
                    </b-col>
                </b-row>
            </b-col>
            <!--<b-col md="2 mt-3">
                <b-button variant="primary" class="btn-back float-left btn-custom" @click="doFilter"><font-awesome-icon icon="search"/></b-button>
            </b-col>-->
        </b-row>
        <paginated-table ref="dataTable" :can-delete="false" :can-paid="false" :can-edit="false" :can-approve="false" :can-reject="false" :data-url="apiUrl.job" :data-key="dataKey" :data-columns="columns" :data-params="['branch_uuid', 'search_name', 'start_time', 'end_time', 'status']">
            <template slot="content_branch_uuid" slot-scope="defaultSlotScope">
                {{defaultSlotScope}}
            </template>
        </paginated-table>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    export default {
        name: 'report-index',
        components: {
            PaginatedTable,
            DatePicker
        },
        data () {
            return {
                dataKey: 'job',
                apiUrl: {
                    profile : window.AppConfig.apiUrl + 'profile',
                    job : window.AppConfig.apiUrl + 'job',
                    branch : window.AppConfig.apiUrl + 'branch',
                    exportTimesheet: window.AppConfig.apiUrl + 'export-job-general'
                },
                branchList: [
                    {
                        value: null,
                        text: 'Branch'
                    }
                ],
                statusList: [
                    {
                        value: null,
                        text: 'Status'
                    },
                    {
                        value: 'New',
                        text: 'New'
                    },
                    {
                        value: 'Completed',
                        text: 'Completed'
                    }
                ],
                columns: [
                    {
                        key: 'userProfile',
                        label: 'Name',
                        sortable: true
                    },
                     {
                         key: 'subject',
                         label: 'Subject',
                         sortable: true
                     },                    
                    // {
                    //     key: 'branchTimesheet',
                    //     label: 'Branch',
                    //     sortable: true
                    // },
                    {
                        key: 'startTime',
                        label: 'Start Time',
                        sortable: true
                    },
                    {
                        key: 'endTime',
                        label: 'End Time',
                        sortable: true
                    },
                    {
                        key: 'statusJobs',
                        label: 'Status'
                    },
                    {
                        key: 'actions',
                        label: ''
                    }
                ],
                tableFilter: {
                    branch: null,
                    status: this.$route.query.status,
                    statusJob: null,
                    branch_uuid: this.$route.query.branch_uuid,
                    date: null,
                    start_time: this.$route.query.start_time,
                    end_time: this.$route.query.end_time
                }
            }
        },
        watch: {
            'tableFilter.date' (value) {
                if (value.length >= 1 && value[0] === null && value[1] === null) {
                    this.tableFilter.date = null
                    this.doFilter()
                } else {
                    this.doFilter()
                }
            },
            'tableFilter.statusJob' () {
                this.doFilter()
            },
            'tableFilter.branch' () {
                this.doFilter()
            },
            'tableFilter.search_name' () {
                this.doFilter()
            },
        },
        mounted () {
            this.getBranch()
        },
        methods: {
            getBranch () {
                this.$http.get(this.apiUrl.branch + '?limit=100&is_active=1').then(resp => {
                    resp.data._embedded.branch.forEach(data => {
                        this.branchList.push({
                            value: data.uuid,
                            text: data.name
                        })
                    })
                })
            },
            doFilter () {
                this.tableFilter.branch_uuid = this.tableFilter.branch
                this.tableFilter.status = this.tableFilter.statusJob
                this.tableFilter.start_time = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD hh:mm:ss') : null
                this.tableFilter.end_time = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD hh:mm:ss') : null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            doExportToExcel () {
              let url = this.apiUrl.exportTimesheet + '?token=' + this.$store.getters['account/tokens'].access_token
              if (this.tableFilter.search_name !== undefined && this.tableFilter.search_name !== null) {
                url += '&search_name=' + this.tableFilter.search_name
              }
              if (this.tableFilter.branch_uuid !== undefined && this.tableFilter.branch_uuid !== null) {
                url += '&branch_uuid=' + this.tableFilter.branch_uuid
              }
              if (this.tableFilter.status !== undefined && this.tableFilter.status !== null) {
                url += '&status=' + this.tableFilter.status
              }
              if (this.tableFilter.date !== null) {
                url += '&start_date=' + this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') + '&end_date=' + this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD')
              }
              window.open(url)
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm')
                } else {
                    return '-'
                }
            },
            reset () {
                this.tableFilter.requestedBy = null
            }
        }
    }
</script>